import { observer } from "mobx-react";
import { FOLLOW_UP_QUESTION_TYPE } from "../../return-reasons/constants";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../components/fonts/font-props";
import Translation from "../../../translation/translation";
import YesNoCRmaFuqAnswer from "./yes-no-c-rma-fuq-answer";
import "./follow-up-question-list.scss";
import CreateRmaFuqStore from "../stores/create-rma-fuq-store";
import SingleChoiceCRmaFuqAnswer from "./single-choice-c-rma-fuq-answer";
import RequestProductStore from "../stores/request-product-store";
import MultipleChoiceCRmaFuqAnswer from "./multiple-choice-c-rma-fuq-answer";
import NumericStepperCRmaFuqAnswer from "./numeric-stepper-crma-fuq-answer";
import MediaUploadCRmaFuqAnswer from "./media-upload-crma-fuq-answer";
import FreeTextCRmaFuqAnswer from "./free-text-crma-fuq-answer";
import useTranslation from "../../../translation/hooks/translation-hook";
import { useEffect } from "react";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";


interface IAnswerComponentProps {
    fuqType: FOLLOW_UP_QUESTION_TYPE;
    question: CreateRmaFuqStore;
    isRequired: boolean;
}

const AnswerComponent: React.FC<IAnswerComponentProps> = ({ fuqType, question, isRequired }) => {

    const {getTranslation} = useTranslation();
    const questionTranslation = getTranslation(question.translationKey);
    useEffect(() => {
        question.setQuestionTranslation(questionTranslation);
    }, [question, questionTranslation]);

    switch (fuqType) {
        case FOLLOW_UP_QUESTION_TYPE.YesNo:
            return <YesNoCRmaFuqAnswer question={question}/> ;
        case FOLLOW_UP_QUESTION_TYPE.MultiChoiceSingleAnswer:
            return <SingleChoiceCRmaFuqAnswer question={question} required={isRequired}/>;
        case FOLLOW_UP_QUESTION_TYPE.MultiChoiceMultipleAnswer:
            return <MultipleChoiceCRmaFuqAnswer question={question} required={isRequired}/>;
        case FOLLOW_UP_QUESTION_TYPE.NumericStepper:
            return <NumericStepperCRmaFuqAnswer question={question} />;
        case FOLLOW_UP_QUESTION_TYPE.ImageRequest:
            return <MediaUploadCRmaFuqAnswer />;
        case FOLLOW_UP_QUESTION_TYPE.FreeText:
            return <FreeTextCRmaFuqAnswer question={question} isRequired={isRequired} />;
        default:
            return <></>;
    }
}


interface IFollowUpQuestionListProps {
    requestProductStore: RequestProductStore;
}
const FollowUpQuestionList: React.FC<IFollowUpQuestionListProps> = observer(( {requestProductStore}) => {

    const fuqStoreList: CreateRmaFuqStore[] = requestProductStore.fuqStoreList;
    const isRerquired: boolean = requestProductStore.requireFuq;
    const showNumbers: boolean = fuqStoreList.length > 1;
    const {getTranslation} = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';

    return(
        <>
            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>Follow up questions</FontBody2>
            { !requestProductStore.returnReasonId &&
                <FontBody2 color={FONT_COLOR.PRIMARY3_50}> {getTranslation('NO_REASON_SELECTED_FUQ_INSTRUCTION', pageScope)} </FontBody2>
            }
            { (fuqStoreList.length === 0) && requestProductStore.returnReasonId &&
                <FontBody2 color={FONT_COLOR.PRIMARY3_50}> {getTranslation('NO_FOLLOW_UP_QUESTIONS', pageScope)} </FontBody2>
            }
            {fuqStoreList.map((question, index) => {
                return (
                    <div key={question.id}  className="create-rma-fuq-qustion">
                        <div>
                            {showNumbers && <FontBody2 color={FONT_COLOR.PRIMARY2}>{index+1}. </FontBody2>}
                            <Translation Font={FontBody2} color={FONT_COLOR.PRIMARY2} translationKey={question.translationKey} />
                            {!!isRerquired && <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT3}>&nbsp;*</FontBody2>}
                        </div>
                        <AnswerComponent fuqType={question.type} question={question} isRequired={isRerquired} />
                    </div>
                )
            })}
        </>
    )
});

export default FollowUpQuestionList;